export default __webpack_public_path__ + "ecfbe578add25f4b3d6c1e45db113c35.svg";